import React, { Component } from 'react'
import {
    Container,
    Form,
    Button,
    Nav,
    NavItem,
    NavLink,
    NavbarBrand
} from 'reactstrap';
import "./randomtest.css"
import { counter } from '@fortawesome/fontawesome-svg-core';
import { UncontrolledCollapse, CardBody, Card } from 'reactstrap';
import {  Modal } from 'react-bootstrap';
import { sample } from "lodash"

class Randomtest extends Component {
    constructor(props, context){
        super(props, context);
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.state = {
            show: false
        };
    }
    handleClose(){
        this.setState({ show: false });
    }
    handleShow(){
        this.setState({ show: true });
    }
    render() {
        let box = ["/randomtest1","/randomtest1_2","/randomtest1_3"]
    
        return (
            <div>
                <Container className="comming">
                <Form className="boxrandomtest">
                        <h1 className="textrandomtest1">แบบทดสอบวัดระดับ</h1>
                        <Form className="Q1">
                           <h3 h5 align='center'>คุณพร้อมที่เข้าทดสอบวัดระดับแล้วหรือไม่</h3>  <br></br>
                           <h3 h5 align='center'>ARE YOU READY</h3><br></br>
                           
                          <NavbarBrand onClick={this.handleShow} className="brand-logo">
                         <h2 align='center' className="starttest" >START</h2>
                          </NavbarBrand> 
                            <Modal show={this.state.show} onHide={this.handleClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>กด START เพื่อยืนยัน</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <h4>คุณพร้อมหรือไม่?</h4>
                                </Modal.Body>
                                <Modal.Footer>
                                <Button href={sample(box)} color="#4fc3f7 light-blue lighten-2" >START</Button>{' '}
                                    <Button onClick={this.handleClose}>Close</Button>
                                </Modal.Footer>
                            </Modal>
                        </Form>
                        
                            
                        
                </Form>
                </Container>
               
                <div className="footer text-footer">
                    <p>Surasak   Noorurk</p>
                    <p> Project 5935512072 Computer Engineering</p>
                    <NavLink href="https://surasak783023869.wordpress.com/">ช่องทางการติดต่อ</NavLink>
                       
                </div>

            </div> 
        )
    }
}

export default Randomtest